import * as styles from './styles.css';
import clsx from 'clsx';
import { Responsive, TDeviceType } from '@cian/ui-kit/responsive';
import { Carousel } from 'shared/components/Carousel';

import { renderBanner } from 'shared/utils/banners';
import { TBannerType } from 'shared/types/banner';
import type { TStepAccent } from 'shared/utils/steps';

export type TFirstStepBackground = 'blue' | 'white';

interface IStepProps {
  step: number;
  title: string;
  slides: React.ReactNode;
  device: TDeviceType;
  mainTitle: string;
  emblaRef: (instance: HTMLDivElement | null) => void;
  scrollPrev: () => void;
  scrollNext: () => void;
  canScrollPrev: boolean;
  canScrollNext: boolean;
  showArrows: boolean;
  showMainTitle: boolean;
  firstBackground?: TFirstStepBackground;
  isMainTitleOutside?: boolean;
  isFirst?: boolean;
  banner?: TBannerType;
  stepAccent?: TStepAccent;
}

export const Step: React.FC<IStepProps> = ({
  step,
  title,
  slides,
  device,
  mainTitle,
  emblaRef,
  scrollPrev,
  scrollNext,
  canScrollPrev,
  canScrollNext,
  showArrows,
  showMainTitle,
  firstBackground = 'blue',
  isMainTitleOutside = false,
  banner,
  isFirst = false,
  stepAccent,
}) => {
  return (
    <div
      className={clsx(
        styles['container'],
        isFirst && firstBackground === 'blue' && styles['first-blue'],
        isFirst && firstBackground === 'white' && styles['first-white'],
        styles[device],
      )}
    >
      {showMainTitle && isMainTitleOutside && (
        <h2 className={clsx(styles['main-title'], styles['main-title-outside'])}>{mainTitle}</h2>
      )}
      <div className={styles['wrapper']}>
        <div className={styles['content']}>
          {showMainTitle && !isMainTitleOutside && <h2 className={styles['main-title']}>{mainTitle}</h2>}
          <div className={styles['nav-container']}>
            <Responsive desktop tablet>
              <div className={clsx(styles['step'], stepAccent && styles[stepAccent])}>{step}</div>
            </Responsive>
            <Responsive phone>
              <div className={clsx(styles['step-text'], stepAccent && styles[stepAccent])}>Шаг {step}</div>
            </Responsive>
            <h3 className={styles['title']}>{title}</h3>
            {showArrows && (
              <div className={styles['arrows']}>
                <button
                  type="button"
                  className={clsx(styles['arrow'], styles['arrow-prev'])}
                  onClick={scrollPrev}
                  disabled={!canScrollPrev}
                  aria-label="Предыдущая статья"
                />
                <button
                  type="button"
                  className={clsx(styles['arrow'], styles['arrow-next'])}
                  onClick={scrollNext}
                  disabled={!canScrollNext}
                  aria-label="Следующая статья"
                />
              </div>
            )}
          </div>
          <Carousel emblaRef={emblaRef}>{slides}</Carousel>
          {banner && <div className={styles['banner']}>{renderBanner(banner)}</div>}
        </div>
      </div>
    </div>
  );
};
